var _rect, _rect2, _line, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.514,
    y: 14.6279,
    width: 83,
    height: 51,
    rx: 5.5,
    transform: "rotate(15 16.514 14.6279)",
    stroke: "#039BE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1846,
    y: 23.3212,
    width: 83,
    height: 9,
    transform: "rotate(15 14.1846 23.3212)",
    stroke: "#039BE5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.3895,
    y1: 41.7431,
    x2: 38.5036,
    y2: 48.4724,
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0955 46.5728L29.4821 51.2315",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.732,
    y: 55.525,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 10.732 55.525)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5616,
    y: 56.819,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 15.5616 56.819)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3913,
    y: 58.1131,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 20.3913 58.1131)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2209,
    y: 59.4073,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 25.2209 59.4073)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9142,
    y: 61.7366,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 33.9142 61.7366)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7438,
    y: 63.0307,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 38.7438 63.0307)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5735,
    y: 64.3248,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 43.5735 64.3248)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4031,
    y: 65.619,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 48.4031 65.619)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0964,
    y: 67.9483,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 57.0964 67.9483)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9261,
    y: 69.2424,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 61.9261 69.2424)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7557,
    y: 70.5364,
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "rotate(15 66.7557 70.5364)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4955 55.8324C78.8508 55.0098 77.9437 54.3817 76.8565 54.0904C74.1891 53.3757 71.4474 54.9586 70.7327 57.6259C70.018 60.2932 71.6009 63.0349 74.2683 63.7496C75.3555 64.0409 76.4551 63.9505 77.4248 63.5605",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.3579,
    cy: 60.4728,
    r: 5,
    transform: "rotate(15 81.3579 60.4728)",
    stroke: "#039BE5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBank);
export default ForwardRef;